module.exports = __webpack_public_path__ + "img/xinmei-logo.9dfc222d.png";